import React from "react";
import { Card } from "./ui/card";
import { Skeleton } from "./ui/skeleton";

export function ResultsSkeleton() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-6 animate-fade-up">
      <div className="lg:col-span-12">
        <Card className="p-5">
          <div className="flex items-center gap-4">
            <Skeleton className="h-12 w-12 rounded-full" />
            <div className="flex-1 space-y-2">
              <Skeleton className="h-4 w-48" />
              <Skeleton className="h-3 w-72" />
            </div>
            <div className="hidden sm:flex gap-2">
              <Skeleton className="h-7 w-20" />
              <Skeleton className="h-7 w-24" />
              <Skeleton className="h-7 w-20" />
            </div>
          </div>
        </Card>
      </div>
      <div className="lg:col-span-4">
        <Card className="p-5 flex flex-col items-center justify-center gap-3">
          <Skeleton className="h-44 w-44 rounded-full" />
          <Skeleton className="h-5 w-24" />
          <Skeleton className="h-3 w-40" />
        </Card>
      </div>
      <div className="lg:col-span-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <Card key={i} className="p-5 space-y-3">
              <Skeleton className="h-4 w-32" />
              <Skeleton className="h-3 w-full" />
              <Skeleton className="h-3 w-2/3" />
            </Card>
          ))}
        </div>
      </div>
      <div className="lg:col-span-12 grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-6">
        <Card className="lg:col-span-7 p-5 space-y-2">
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-3 w-3/4" />
        </Card>
        <Card className="lg:col-span-5 p-5 space-y-2">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-3 w-2/3" />
        </Card>
      </div>
    </div>
  );
}
